import React from "react";
import { Navigate } from "react-router-dom";
import PropTypes from "prop-types";

import { useSelector } from "react-redux";

const HomePrivateRoute = ({ children }) => {
  const { token } = useSelector((state) => state.login);

  return token ? (
    <div>
      <>{children}</>
    </div>
  ) : (
    <Navigate to="/" />
  );
};

HomePrivateRoute.propTypes = {
  children: PropTypes.element.isRequired,
};

export default HomePrivateRoute;
